import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import data from "../../data/WorkshopSesction.json";

const PREFIX = "SmsWorkshop";

const classes = {
  backgroundDesign2: `${PREFIX}-backgroundDesign2`,
  exploreProductLink: `${PREFIX}-exploreProductLink`,
  tabContainerBlock: `${PREFIX}-tabContainerBlock`,
  productTabsDesc: `${PREFIX}-productTabsDesc`,
  productImage: `${PREFIX}-productImage`,
  exploreAnchorLink: `${PREFIX}-exploreAnchorLink`,
  root: `${PREFIX}-root`,
  listItem: `${PREFIX}-listItem`,
  title: `${PREFIX}-title`,
  bulletList: `${PREFIX}-bulletList`,
  bulletPoint: `${PREFIX}-bulletPoint`,
  bulletIcon: `${PREFIX}-bulletIcon`,
  imageContainer: `${PREFIX}-imageContainer`,
  contentContainer: `${PREFIX}-contentContainer`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.root}`]: {
    "& .MuiGrid2-root": {
      padding: "0 24px 0 40px",
    },
  },
  [`& .${classes.backgroundDesign2}`]: {
    backgroundColor: "#fefbfb",
  },
  [`& .${classes.tabContainerBlock}`]: {
    padding: "3em 24px 24px 24px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 0 1em 0 !important",
    },
  },
  [`& .${classes.productTabsDesc}`]: {
    padding: "1em",
    fontFamily: "AvenirLTStd-Book",
    fontSize: 23,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },
  [`& .${classes.exploreProductLink}`]: {
    textAlign: "left",
    padding: "1em 1em 1em 1.5em",
    [theme.breakpoints.down("sm")]: {
      padding: "0 1em",
    },
  },
  [`& .${classes.exploreAnchorLink}`]: {
    textDecoration: "none",
    color: "#B41E1C",
    fontFamily: " AvenirLTStd-Roman",
    fontSize: 26,
    fontWeight: 700,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.2rem",
    },
    "@media (min-width: 375px)": {
      fontSize: 18,
    },
    "@media (min-width: 800px)": {
      fontSize: 26,
    },
    "@media (min-width: 1280px)": {
      fontSize: 30,
    },
  },
  [`& .${classes.listItem}`]: {
    display: "flex",
    alignItems: "center",
  },
  [`& .${classes.title}`]: {
    fontWeight: "bold",
    color: "#223140",
    fontFamily: "AvenirLTStd-Book",
    mb: 2,
    paddingLeft: "1em",
    fontSize: 24,
    fontFamily: " AvenirLTStd-Roman",
    "@media (min-width: 375px)": {
      fontSize: 22,
    },
    "@media (min-width: 800px)": {
      fontSize: 25,
    },
    "@media (min-width: 1280px)": {
      fontSize: 25,
    },
  },
  [`& .${classes.bulletList}`]: {
    paddingLeft: "1.5em",
    listStyleType: "none",
  },
  [`& .${classes.bulletPoint}`]: {
    display: "flex",
    alignItems: "center",
    fontFamily: " AvenirLTStd-Roman",
    fontSize: 22,
    marginBottom: "0.5em",
    "@media (min-width: 375px)": {
      fontSize: 16,
    },
    "@media (min-width: 800px)": {
      fontSize: 22,
    },
    "@media (min-width: 1280px)": {
      fontSize: 22,
    },
  },
  [`& .${classes.bulletIcon}`]: {
    marginRight: "0.5em",
    color: "#56aeff",
  },
  [`& .${classes.imageContainer}`]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  [`& .${classes.contentContainer}`]: {
    display: "flex",
    alignSelf: "center",
    flexDirection: "column",
  },
}));

const SmsWorkshop = () => {

  return (
    <StyledGrid container className={classes.root}>
      <Grid
        size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        className={[classes.tabContainerBlock, classes.productTabsDesc].join(
          " "
        )}
      >
        <Typography component="div" className={classes.tabContainerBlock}>
          <Grid container className="product-tab-container">
            <Grid
              size={{ xs: 12, sm: 6, md: 6, lg: 6 }}
              className={classes.contentContainer}
            >
              <span className="product-content-border-top" />
              <Typography variant="h6" className={classes.title}>
                {data.title}
              </Typography>
              <Typography variant="body1" className={classes.productTabsDesc}>
                {data.description1}
              </Typography>
              <Typography variant="body1" className={classes.productTabsDesc}>
                {data.description2}
              </Typography>
              <Typography variant="body1" className={classes.productTabsDesc}>
                {data.description3}
              </Typography>
              <Typography variant="body1" className={classes.productTabsDesc}>
                {data.description4}
              </Typography>
              <Typography
                variant="body1"
                className={classes.productTabsDesc}
              >
                By joining our workshops, you’ll:
              </Typography>
              <ul className={classes.bulletList}>
                {data.bulletPoints.map((point, index) => (
                  <li key={index} className={classes.bulletPoint}>
                    <ArrowRightIcon className={classes.bulletIcon} />
                    {point}
                  </li>
                ))}
              </ul>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 6, lg: 6 }}
              className={classes.imageContainer}
            >
              <img
                alt="product"
                className={classes.productImage}
                src={data.imagePath}
              />
            </Grid>
          </Grid>
        </Typography>
      </Grid>
    </StyledGrid>
  );
};

export default SmsWorkshop;
